export { default } from '@/fragments/user-access/unauthorized';
